var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "form-separation-element" } }, [
    _c("div", { staticClass: "form-separation-element" }, [
      _c("hr", { style: _vm.hrStyle }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }